/**
 * map-modal
 */

import $ from 'jquery';

class MapModal {
  constructor() {
    this.$ = {
      document: $(document),
      root: $('.js-map-modal'),
      title: $('.js-map-modal-title')
    };

    if (this.$.root.length) {
      this.init();
    }
  }
  init() {
    this.param = {};
    this.markers = {};

    $.getScript('//api-maps.yandex.ru/2.1/?lang=ru_RU', () => {
      this.setParams();
      this.events();
    });
  }
  setParams() {
    const data = this.$.root.data('init');

    this.param.coords = data.coords;
    this.param.image = data.image;
    this.param.zoom = data.zoom;
    this.param.title = '';
  }
  events() {
    this.$.document.on('click', '[data-map-modal]', e => this.open(e));
    this.$.document.on('click', '[data-map-modal-close]', () => this.close());

    this.$.root.on('click', e => {
      const $target = $(e.target);

      if (!$target.closest('.js-map-modal-box').length) {
        this.close();
      }
    });

    ymaps.ready(() => this.initMap());
  }
  initMap() {
    this.map = new ymaps.Map(
      'map-modal',
      {
        center: this.param.coords,
        zoom: this.param.zoom,
        controls: []
      },
      {
        searchControlProvider: false
      }
    );
  }
  setMarker() {
    if (this.param.coords.toString() in this.markers) return;

    const marker = new ymaps.Placemark(
      this.param.coords,
      {},
      {
        iconImageHref: this.param.image,
        iconLayout: 'default#image',
        iconImageSize: [50, 72],
        iconImageOffset: [-25, -72]
      }
    );

    this.map.geoObjects.add(marker);
    this.markers[this.param.coords.toString()] = marker;
  }
  setCenter() {
    this.map.setCenter(this.param.coords, this.param.zoom);
  }
  open(e) {
    const $target = $(e.target);
    const data = $target.data('mapModal');

    this.param.coords = data.coords;
    this.param.title = data.title;

    this.setMarker();
    this.setCenter();

    this.$.title.text(this.param.title);
    this.$.root.fadeIn(200).addClass('is-open');
  }
  close() {
    this.$.root.fadeOut(200).removeClass('is-open');
  }
}

export default new MapModal();
